import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getVendor = createAsyncThunk("app/getVendor", async (id) => {
  const res = await axios.get(`/api/vendor?id=${id}`);
  return res.data;
});

export const getVendors = createAsyncThunk(
  "app/getVendors",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/vendor/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addVendor = createAsyncThunk(
  "app/addVendor",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.post("api/vendor", body, config);
      successAlertHandle("Vendor added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getDocImage = async (id, name) => {
  try {
    const res = await axios.get(
      `/api/image?profile=vendor&id=${id}&name=${name}`
    );
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

export const updateVendor = createAsyncThunk(
  "app/updateVendor",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/vendor", body, config);
      successAlertHandle("Vendor updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteVendor = createAsyncThunk(
  "app/deleteVendor",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/vendor?id=${id}`);
      successAlertHandle("Vendor deleted successfully!", dispatch);
      dispatch(setDeleteLoading(true));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);



